import { Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class TagService {

  constructor(
    private titleService: Title,
    private metaService: Meta
  ) { }
  
  setTitle(title) {
    this.titleService.setTitle(title)
  }

  setMetaTags(tags = []) {
    tags.forEach(tag => {
      this.metaService.updateTag({ 
        [tag.name? 'name' : 'property']: tag.name? tag.name : tag.property,
        content: tag.content
      })
    })
  }

  addMetaTags(tags = []) {
    tags.forEach(tag => {
      this.metaService.addTag({ 
        [tag.name? 'name' : 'property']: tag.name? tag.name : tag.property,
        content: tag.content
      }, true)
    })
  }
}
